import { useState, useEffect } from 'react';

import classes from './ProviderProgress.module.scss';
import figure from '../../../images/progress-figure.svg';
import CircularProgressWithLabel from '../../components/CircularProgressWithLabel';
import CustomButton from '../../components/CustomButton';
import { Dialog } from '@mui/material';
import ProgressDialog from './progressDialog';

import ACTIONS from '../../../redux/action';
import { useDispatch } from 'react-redux';
import i18n from '../../../utils/i18n';
import circle from '../../../images/circle.svg';
import checkCircle from '../../../images/check-circle.svg';

//force deploy

const ProviderProgress = ({
	providerData,
	allCompleted,
	setAllCompleted,
	submitToDB,
}) => {
	const [open, setOpen] = useState(false);
	const [progressValue, setProgressValue] = useState(0);
	const dispatch = useDispatch();
	const tabs = [
		{ label: i18n.t('provider.profilesettings'), id: 'profilesettings' },
		{ label: i18n.t('provider.companyinfo'), id: 'companyinfo' },
		{ label: i18n.t('provider.services'), id: 'services' },
		{ label: i18n.t('provider.clientfilters'), id: 'clientfilters' },
		{ label: i18n.t('provider.pricing'), id: 'pricing' },
	];

	const checkAllCompleted = () => {
		let progress = 0;

		if (
			providerData.provider_onboarding?.profilesettings_flow?.iscompleted ===
			true
		) {
			progress += 20;
		}
		if (
			providerData.provider_onboarding?.companyinfo_flow?.iscompleted === true
		) {
			progress += 20;
		}
		if (
			providerData.provider_onboarding?.clientfilters_flow?.iscompleted === true
		) {
			progress += 20;
		}
		if (providerData.provider_onboarding?.services_flow?.iscompleted === true) {
			progress += 20;
		}
		if (providerData.provider_onboarding?.pricing_flow?.iscompleted === true) {
			progress += 20;
		}
		console.log('PROGRESS', progress, 'ALL COMPLETED', allCompleted);
		return progress;
	};

	useEffect(() => {
		const newProgressValue = checkAllCompleted();

		if (newProgressValue !== progressValue) {
			setProgressValue(newProgressValue);
		}
	}, [providerData]);

	useEffect(() => {
		// console.log('PROG VALUE, ALL COMPLETED', progressValue, allCompleted);
		if (progressValue === 100 && !allCompleted) {
			setAllCompleted(true);
			dispatch(
				ACTIONS.addProviderInfo({
					id: 'finishedRegistration',
					data: true,
					stateObject: 'userData',
				})
			);
			dispatch(
				ACTIONS.updateProviderInfo({
					stateObject: 'finishedRegistration',
					data: true,
				})
			);
			// console.log('FINISHED DISPATCHES');
		}
	}, [progressValue, allCompleted, dispatch]);

	const profileChecker = {
		companyName: providerData.provider_info.companyname,
		description: providerData.provider_info.description,
		email: providerData.provider_info.email,
		phone: providerData.provider_info.phone,
		packageSize: providerData.provider_package.packageSize,
	};

	const infoChecker = {
		companyName: providerData.provider_info.companyname,
		taxnumber: providerData.provider_info.taxnumber,
		registrationno: providerData.provider_info.registrationno,
		authorizedperson: providerData.provider_info.authorizedperson,
		zip: providerData.provider_info.zip,
		city: providerData.provider_info.city,
		address: providerData.provider_info.address,
	};
	const source = providerData.provider_acc_monthly_price;
	const priceChecker = Object.fromEntries(
		Object.entries({
			singleprimaryprice: source.singleprimaryprice,
			kivaprice: source.kivaprice,
			kftprice: source.kftprice,
			zrtprice: source.zrtprice,
			civilprice: source.civilprice,
			revfeecat1: source.revfeecat1,
			revfeecat2: source.revfeecat2,
			revfeecat3: source.revfeecat3,
			revfeecat4: source.revfeecat4,
			revfeecat5: source.revfeecat5,
			revfeecat6: source.revfeecat6,
			revfeecat7: source.revfeecat7,
			vatyearly: source.vatyearly,
			vatquarterly: source.vatquarterly,
			vatmonthly: source.vatmonthly, // (fixed typo from "vatmonyhly")
		}).filter(([_, v]) => v !== undefined && v !== null)
	);

	const valueCheck = (data) => {
		if (typeof data === 'object' && data !== null) {
			const values = Object.values(data);

			return values.every(
				(value) =>
					value !== undefined && value !== null && value !== '' && value !== 0
			);
		}
		return false;
	};

	const priceCheck = (data) => {
		if (typeof data === 'object' && data !== null) {
			console.log(typeof data, 'TYPEOF DATA');
			return Object.entries(data).every(([key, value]) => {
				if (key.startsWith('revfeecat') || key.startsWith('vat')) {
					console.log('INSIDE 2 IF');
					return value !== undefined && value !== null && value !== '';
				} else {
					console.log('INSIDE 3 IF');
					return (
						value !== 0 && value !== undefined && value !== null && value !== ''
					);
				}
			});
		}
		return false;
	};

	useEffect(() => {
		if (valueCheck(profileChecker) === true) {
			dispatch(
				ACTIONS.updateNestedObject({
					id: 'iscompleted',
					data: true,
					stateObject: 'provider_onboarding',
					stateObjectID: 'profilesettings_flow',
				})
			);
		} else {
			dispatch(
				ACTIONS.updateNestedObject({
					id: 'iscompleted',
					data: false,
					stateObject: 'provider_onboarding',
					stateObjectID: 'profilesettings_flow',
				})
			);
		}
		if (valueCheck(infoChecker) === true) {
			dispatch(
				ACTIONS.updateNestedObject({
					id: 'iscompleted',
					data: true,
					stateObject: 'provider_onboarding',
					stateObjectID: 'companyinfo_flow',
				})
			);
		} else {
			dispatch(
				ACTIONS.updateNestedObject({
					id: 'iscompleted',
					data: false,
					stateObject: 'provider_onboarding',
					stateObjectID: 'companyinfo_flow',
				})
			);
		}
		if (priceCheck(priceChecker) === true) {
			dispatch(
				ACTIONS.updateNestedObject({
					id: 'iscompleted',
					data: true,
					stateObject: 'provider_onboarding',
					stateObjectID: 'pricing_flow',
				})
			);
		} else {
			dispatch(
				ACTIONS.updateNestedObject({
					id: 'iscompleted',
					data: false,
					stateObject: 'provider_onboarding',
					stateObjectID: 'pricing_flow',
				})
			);
		}
		if (
			providerData.provider_onboarding?.services_flow?.iscompleted === undefined
		) {
			dispatch(
				ACTIONS.updateNestedObject({
					id: 'iscompleted',
					data: false,
					stateObject: 'provider_onboarding',
					stateObjectID: 'services_flow',
				})
			);
		}
		if (
			providerData.provider_onboarding?.clientfilters_flow?.iscompleted ===
			undefined
		) {
			dispatch(
				ACTIONS.updateNestedObject({
					id: 'iscompleted',
					data: false,
					stateObject: 'provider_onboarding',
					stateObjectID: 'clientfilters_flow',
				})
			);
		}
	}, []);

	return (
		<>
			<Dialog open={open} onClose={() => setOpen(false)}>
				<ProgressDialog
					setOpen={setOpen}
					tabs={tabs}
					providerData={providerData}
				/>
			</Dialog>
			{allCompleted ? null : (
				<div className={classes.progressContainer}>
					<div className={classes.progressTitle}>
						{i18n.t('provider.incompleteprofile')}{' '}
						<CircularProgressWithLabel
							value={progressValue}
							textColor="#ffffff"
							showBg={true}
							size={32}
							fontSize={8}
						/>
					</div>
					<div className={classes.tabsContainer}>
						{tabs.map((e, idx) => {
							return (
								<p className={classes.tab} key={idx}>
									<img
										alt="check mark"
										src={
											!providerData?.provider_onboarding[`${e.id}_flow`]
												?.iscompleted
												? circle
												: checkCircle
										}
									/>{' '}
									<span
										className={
											providerData?.provider_onboarding[`${e.id}_flow`]
												?.iscompleted
												? classes.complete
												: null
										}>
										{e.label}
									</span>
								</p>
							);
						})}
					</div>

					<div className={classes.ctcContainer}>
						<CustomButton
							buttonName={i18n.t('provider.fillprofile')}
							buttonColor="rgba(28, 50, 243, 1)"
							titleColor="#ffffff"
							width="188px"
							height="36px"
							padding="8px"
							onClick={() => setOpen(true)}
						/>
					</div>
					<img className={classes.figure} src={figure} alt="cool guy" />
				</div>
			)}
		</>
	);
};

export default ProviderProgress;
